import { gql } from "@apollo/client";

export const THREAD_ACTION_FIELDS = gql`
  fragment ThreadActionFields on ThreadAction {
    id
    actionType
    createdAt
    performedByUser {
      id
      fullName
    }
    campaign {
      id
      name
    }
  }
`;
